import { useState } from "react";
import { useModal } from "../../../../../../hooks/ModalContext";
import { Button } from "../../../../../generics/button";
import { Input } from "../../../../../generics/input-group";
import { useCadastro } from "../../../../../../context/CadastroContext";
import { useDividas } from "../../../../../../context/DividasContext";
import { DadosCadastrais, Endereco } from "../../../../../../types/devedor-interface";
import { useFila } from "../../../../../../context/FilaContext";
import { format } from "date-fns";
import { useAuth } from "../../../../../../context/AuthContext";

interface EmailModalProps {
  isToSave?: boolean
  app?: string
  isOperador?: boolean
}

interface DadosEmail {
  email: string;
  tipo_email: string;
  situacaoemail: string;
  origememail: string;
  id_email?: string;
}

export const EmailModal = ({ isToSave, isOperador, app }: EmailModalProps) => {
  const { infoEmail, onClose, setModal } = useModal()
  const { getEmail, atualizaDevedorCadastro, emails } = useCadastro()
  const { selectedCredor, devedor, getDevedorCadastro, devedorCadastro } = useDividas()
  const [situacao, setSituacao] = useState('VALIDO')
  const { cookies } = useAuth()
  // const [email, setEmail] = useState<DadosEmail>(infoEmail?.id_email ? infoEmail : {} as DadosEmail)
  const [valueEmail, setValueEmail] = useState(infoEmail?.id_email ? infoEmail.email : '')
  const appWS = app ? app : isOperador ? 'ACIONA_OPE' : 'ACIONA_WEB'


  function verificarEmail(email: string) {
    if (emails.find(item => item.email === email)) {
      return false
    }
    return true
  }


  async function addEmail() {
    if (valueEmail !== '' && !infoEmail.email) {
      const isEmailExist = verificarEmail(valueEmail)
      if (!isEmailExist) {
        setModal('Email já existente na base de dados', 'Erro', false, true)
        return
      }
    }

    let em = {} as DadosEmail
    if (infoEmail?.id_email) {
      em.id_email = infoEmail?.id_email
    }
    em.email = valueEmail === '' && infoEmail.email ? infoEmail.email : valueEmail
    em.origememail = infoEmail && infoEmail.origememail ? infoEmail.origememail : 'Manual'
    em.tipo_email = 'Particular'
    em.situacaoemail = situacao.toLocaleLowerCase()

    if (em.email === '') {
      setModal('o campo de email não pode estar vazio', 'Erro', false, true)
      return
    }


    if (isToSave) {
      const cpf_cnpj = devedor?.cpf_cnpj.replace(/\D/g, '') || ''
      const status = await atualizaDevedorCadastro({ dadosCadastrais: {} as DadosCadastrais, endereco: {} as Endereco, cpf_cnpj, url: selectedCredor.url_ws, codcredor: String(selectedCredor.credor_crm), email: em, usuario: String(cookies?.user?.id_operador), nomeclien: devedor.name, datnasc: devedorCadastro?.datnasc })
      await getDevedorCadastro(selectedCredor.url_ws, cpf_cnpj, selectedCredor.credor_crm, appWS)

      if (status === 200) {
        setModal('Devedor atualizado com sucesso!', 'Sucesso', true)
      }

    } else {
      getEmail(em, infoEmail.email)
    }

    onClose()
  }


  return (
    <div>
      <form className="flex flex-col items-end">
        <Input name="E-mail" placeholder={infoEmail?.email ? infoEmail?.email : ''} value={valueEmail} onChange={(e) => setValueEmail(e.target.value)} />
        <div className="mb-4 mt-2 flex h-8 w-full items-center justify-between gap-4">
          <p className="w-2/6 font-medium text-gray-700">Situação: </p>
          <select className="h-full w-full bg-gray-200 px-1 py-2" value={situacao.toLocaleUpperCase()} onChange={(e) => setSituacao(e.target.value)}>
            {infoEmail?.email && <option value="VALIDO">VALIDO</option>}
            <option value="ATUALIZADO">ATUALIZADO</option>
            {infoEmail?.id_email && infoEmail?.id_email.length > 0 && <option value="INVALIDO">INVALIDO</option>}

          </select>
        </div>
        <Button name="Salvar" width="w-2/6" type="button" onClick={() => addEmail()} />
      </form>
    </div>
  );
};
